export interface Location {
  city: string;
  state: string;
  stateCode: string;
}

export const locations: Location[] = [
  { city: "New York", state: "New York", stateCode: "NY" },
  { city: "Los Angeles", state: "California", stateCode: "CA" },
  { city: "Chicago", state: "Illinois", stateCode: "IL" },
  { city: "Houston", state: "Texas", stateCode: "TX" },
  { city: "Phoenix", state: "Arizona", stateCode: "AZ" },
  { city: "Philadelphia", state: "Pennsylvania", stateCode: "PA" },
  { city: "San Antonio", state: "Texas", stateCode: "TX" },
  { city: "San Diego", state: "California", stateCode: "CA" },
  { city: "Dallas", state: "Texas", stateCode: "TX" },
  { city: "San Jose", state: "California", stateCode: "CA" },
  { city: "Austin", state: "Texas", stateCode: "TX" },
  { city: "Jacksonville", state: "Florida", stateCode: "FL" },
  { city: "Fort Worth", state: "Texas", stateCode: "TX" },
  { city: "Columbus", state: "Ohio", stateCode: "OH" },
  { city: "San Francisco", state: "California", stateCode: "CA" },
  { city: "Charlotte", state: "North Carolina", stateCode: "NC" },
  { city: "Indianapolis", state: "Indiana", stateCode: "IN" },
  { city: "Seattle", state: "Washington", stateCode: "WA" },
  { city: "Denver", state: "Colorado", stateCode: "CO" },
  { city: "Washington", state: "District of Columbia", stateCode: "DC" },
  { city: "Boston", state: "Massachusetts", stateCode: "MA" },
  { city: "El Paso", state: "Texas", stateCode: "TX" },
  { city: "Detroit", state: "Michigan", stateCode: "MI" },
  { city: "Nashville", state: "Tennessee", stateCode: "TN" },
  { city: "Portland", state: "Oregon", stateCode: "OR" },
  { city: "Memphis", state: "Tennessee", stateCode: "TN" },
  { city: "Oklahoma City", state: "Oklahoma", stateCode: "OK" },
  { city: "Las Vegas", state: "Nevada", stateCode: "NV" },
  { city: "Louisville", state: "Kentucky", stateCode: "KY" },
  { city: "Baltimore", state: "Maryland", stateCode: "MD" },
  { city: "Milwaukee", state: "Wisconsin", stateCode: "WI" },
  { city: "Albuquerque", state: "New Mexico", stateCode: "NM" },
  { city: "Tucson", state: "Arizona", stateCode: "AZ" },
  { city: "Fresno", state: "California", stateCode: "CA" },
  { city: "Sacramento", state: "California", stateCode: "CA" },
  { city: "Mesa", state: "Arizona", stateCode: "AZ" },
  { city: "Kansas City", state: "Missouri", stateCode: "MO" },
  { city: "Atlanta", state: "Georgia", stateCode: "GA" },
  { city: "Long Beach", state: "California", stateCode: "CA" },
  { city: "Colorado Springs", state: "Colorado", stateCode: "CO" },
  { city: "Raleigh", state: "North Carolina", stateCode: "NC" },
  { city: "Miami", state: "Florida", stateCode: "FL" },
  { city: "Virginia Beach", state: "Virginia", stateCode: "VA" },
  { city: "Omaha", state: "Nebraska", stateCode: "NE" },
  { city: "Oakland", state: "California", stateCode: "CA" },
  { city: "Minneapolis", state: "Minnesota", stateCode: "MN" },
  { city: "Tulsa", state: "Oklahoma", stateCode: "OK" },
  { city: "Arlington", state: "Texas", stateCode: "TX" },
  { city: "Tampa", state: "Florida", stateCode: "FL" },
  { city: "New Orleans", state: "Louisiana", stateCode: "LA" },
  { city: "Wichita", state: "Kansas", stateCode: "KS" },
  { city: "Cleveland", state: "Ohio", stateCode: "OH" },
  { city: "Bakersfield", state: "California", stateCode: "CA" },
  { city: "Aurora", state: "Colorado", stateCode: "CO" },
  { city: "Anaheim", state: "California", stateCode: "CA" },
  { city: "Honolulu", state: "Hawaii", stateCode: "HI" },
  { city: "Santa Ana", state: "California", stateCode: "CA" },
  { city: "Riverside", state: "California", stateCode: "CA" },
  { city: "Corpus Christi", state: "Texas", stateCode: "TX" },
  { city: "Lexington", state: "Kentucky", stateCode: "KY" },
  { city: "Henderson", state: "Nevada", stateCode: "NV" },
  { city: "Stockton", state: "California", stateCode: "CA" },
  { city: "Saint Paul", state: "Minnesota", stateCode: "MN" },
  { city: "Cincinnati", state: "Ohio", stateCode: "OH" },
  { city: "St. Louis", state: "Missouri", stateCode: "MO" },
  { city: "Pittsburgh", state: "Pennsylvania", stateCode: "PA" },
  { city: "Greensboro", state: "North Carolina", stateCode: "NC" },
  { city: "Lincoln", state: "Nebraska", stateCode: "NE" },
  { city: "Anchorage", state: "Alaska", stateCode: "AK" },
  { city: "Plano", state: "Texas", stateCode: "TX" },
  { city: "Orlando", state: "Florida", stateCode: "FL" },
  { city: "Irvine", state: "California", stateCode: "CA" },
  { city: "Newark", state: "New Jersey", stateCode: "NJ" },
  { city: "Durham", state: "North Carolina", stateCode: "NC" },
  { city: "Chula Vista", state: "California", stateCode: "CA" },
  { city: "Toledo", state: "Ohio", stateCode: "OH" },
  { city: "Fort Wayne", state: "Indiana", stateCode: "IN" },
  { city: "St. Petersburg", state: "Florida", stateCode: "FL" },
  { city: "Laredo", state: "Texas", stateCode: "TX" },
  { city: "Jersey City", state: "New Jersey", stateCode: "NJ" },
  { city: "Chandler", state: "Arizona", stateCode: "AZ" },
  { city: "Madison", state: "Wisconsin", stateCode: "WI" },
  { city: "Lubbock", state: "Texas", stateCode: "TX" },
  { city: "Scottsdale", state: "Arizona", stateCode: "AZ" },
  { city: "Reno", state: "Nevada", stateCode: "NV" },
  { city: "Buffalo", state: "New York", stateCode: "NY" },
  { city: "Gilbert", state: "Arizona", stateCode: "AZ" },
  { city: "Glendale", state: "Arizona", stateCode: "AZ" },
  { city: "North Las Vegas", state: "Nevada", stateCode: "NV" },
  { city: "Winston-Salem", state: "North Carolina", stateCode: "NC" },
  { city: "Chesapeake", state: "Virginia", stateCode: "VA" },
  { city: "Norfolk", state: "Virginia", stateCode: "VA" },
  { city: "Fremont", state: "California", stateCode: "CA" },
  { city: "Garland", state: "Texas", stateCode: "TX" },
  { city: "Irving", state: "Texas", stateCode: "TX" },
  { city: "Hialeah", state: "Florida", stateCode: "FL" },
  { city: "Richmond", state: "Virginia", stateCode: "VA" },
  { city: "Boise", state: "Idaho", stateCode: "ID" },
  { city: "Spokane", state: "Washington", stateCode: "WA" },
  { city: "Baton Rouge", state: "Louisiana", stateCode: "LA" },
  { city: "Tacoma", state: "Washington", stateCode: "WA" },
  { city: "San Bernardino", state: "California", stateCode: "CA" },
  { city: "Modesto", state: "California", stateCode: "CA" },
  { city: "Fontana", state: "California", stateCode: "CA" },
  { city: "Des Moines", state: "Iowa", stateCode: "IA" },
  { city: "Moreno Valley", state: "California", stateCode: "CA" },
  { city: "Santa Clarita", state: "California", stateCode: "CA" },
  { city: "Fayetteville", state: "North Carolina", stateCode: "NC" },
  { city: "Birmingham", state: "Alabama", stateCode: "AL" },
  { city: "Oxnard", state: "California", stateCode: "CA" },
  { city: "Rochester", state: "New York", stateCode: "NY" },
  { city: "Port St. Lucie", state: "Florida", stateCode: "FL" },
  { city: "Grand Rapids", state: "Michigan", stateCode: "MI" },
  { city: "Huntsville", state: "Alabama", stateCode: "AL" },
  { city: "Salt Lake City", state: "Utah", stateCode: "UT" },
  { city: "Frisco", state: "Texas", stateCode: "TX" },
  { city: "Yonkers", state: "New York", stateCode: "NY" },
  { city: "Amarillo", state: "Texas", stateCode: "TX" },
  { city: "Worcester", state: "Massachusetts", stateCode: "MA" },
  { city: "Augusta", state: "Georgia", stateCode: "GA" },
  { city: "Glendale", state: "California", stateCode: "CA" },
  { city: "Mobile", state: "Alabama", stateCode: "AL" },
  { city: "Grand Prairie", state: "Texas", stateCode: "TX" },
  { city: "Little Rock", state: "Arkansas", stateCode: "AR" },
  { city: "Huntington Beach", state: "California", stateCode: "CA" },
  { city: "Akron", state: "Ohio", stateCode: "OH" },
  { city: "McKinney", state: "Texas", stateCode: "TX" },
  { city: "Montgomery", state: "Alabama", stateCode: "AL" },
  { city: "Arlington", state: "Virginia", stateCode: "VA" },
  { city: "Shreveport", state: "Louisiana", stateCode: "LA" },
  { city: "Columbus", state: "Georgia", stateCode: "GA" },
  { city: "Aurora", state: "Illinois", stateCode: "IL" },
  { city: "Overland Park", state: "Kansas", stateCode: "KS" },
  { city: "Tallahassee", state: "Florida", stateCode: "FL" },
  { city: "Knoxville", state: "Tennessee", stateCode: "TN" },
  { city: "Providence", state: "Rhode Island", stateCode: "RI" },
  { city: "Newport News", state: "Virginia", stateCode: "VA" },
  { city: "Fort Lauderdale", state: "Florida", stateCode: "FL" },
  { city: "Rancho Cucamonga", state: "California", stateCode: "CA" },
  { city: "Santa Rosa", state: "California", stateCode: "CA" },
  { city: "Chattanooga", state: "Tennessee", stateCode: "TN" },
  { city: "Oceanside", state: "California", stateCode: "CA" },
  { city: "Tempe", state: "Arizona", stateCode: "AZ" },
  { city: "Garden Grove", state: "California", stateCode: "CA" },
  { city: "Vancouver", state: "Washington", stateCode: "WA" },
  { city: "Cape Coral", state: "Florida", stateCode: "FL" },
  { city: "Sioux Falls", state: "South Dakota", stateCode: "SD" },
  { city: "Springfield", state: "Missouri", stateCode: "MO" },
  { city: "Peoria", state: "Arizona", stateCode: "AZ" },
  { city: "Pembroke Pines", state: "Florida", stateCode: "FL" },
  { city: "Elk Grove", state: "California", stateCode: "CA" },
  { city: "Salem", state: "Oregon", stateCode: "OR" },
  { city: "Lancaster", state: "California", stateCode: "CA" },
  { city: "Corona", state: "California", stateCode: "CA" },
  { city: "Eugene", state: "Oregon", stateCode: "OR" },
  { city: "Palmdale", state: "California", stateCode: "CA" },
  { city: "Salinas", state: "California", stateCode: "CA" },
  { city: "Springfield", state: "Massachusetts", stateCode: "MA" },
  { city: "Pasadena", state: "Texas", stateCode: "TX" },
  { city: "Fort Collins", state: "Colorado", stateCode: "CO" },
  { city: "Hayward", state: "California", stateCode: "CA" },
  { city: "Pomona", state: "California", stateCode: "CA" },
  { city: "Cary", state: "North Carolina", stateCode: "NC" },
  { city: "Rockford", state: "Illinois", stateCode: "IL" },
  { city: "Alexandria", state: "Virginia", stateCode: "VA" },
  { city: "Escondido", state: "California", stateCode: "CA" },
  { city: "McKinney", state: "Texas", stateCode: "TX" },
  { city: "Kansas City", state: "Kansas", stateCode: "KS" },
  { city: "Joliet", state: "Illinois", stateCode: "IL" },
  { city: "Sunnyvale", state: "California", stateCode: "CA" },
  { city: "Torrance", state: "California", stateCode: "CA" },
  { city: "Bridgeport", state: "Connecticut", stateCode: "CT" },
  { city: "Lakewood", state: "Colorado", stateCode: "CO" },
  { city: "Hollywood", state: "Florida", stateCode: "FL" },
  { city: "Paterson", state: "New Jersey", stateCode: "NJ" },
  { city: "Naperville", state: "Illinois", stateCode: "IL" },
  { city: "Syracuse", state: "New York", stateCode: "NY" },
  { city: "Mesquite", state: "Texas", stateCode: "TX" },
  { city: "Dayton", state: "Ohio", stateCode: "OH" },
  { city: "Savannah", state: "Georgia", stateCode: "GA" },
  { city: "Clarksville", state: "Tennessee", stateCode: "TN" },
  { city: "Orange", state: "California", stateCode: "CA" },
  { city: "Pasadena", state: "California", stateCode: "CA" },
  { city: "Fullerton", state: "California", stateCode: "CA" },
  { city: "Killeen", state: "Texas", stateCode: "TX" },
  { city: "Frisco", state: "Texas", stateCode: "TX" },
  { city: "Hampton", state: "Virginia", stateCode: "VA" },
  { city: "McAllen", state: "Texas", stateCode: "TX" },
  { city: "Warren", state: "Michigan", stateCode: "MI" },
  { city: "Bellevue", state: "Washington", stateCode: "WA" },
  { city: "West Valley City", state: "Utah", stateCode: "UT" },
  { city: "Columbia", state: "South Carolina", stateCode: "SC" },
  { city: "Olathe", state: "Kansas", stateCode: "KS" },
  { city: "Sterling Heights", state: "Michigan", stateCode: "MI" },
  { city: "New Haven", state: "Connecticut", stateCode: "CT" },
  { city: "Miramar", state: "Florida", stateCode: "FL" },
  { city: "Waco", state: "Texas", stateCode: "TX" },
  { city: "Thousand Oaks", state: "California", stateCode: "CA" },
  { city: "Cedar Rapids", state: "Iowa", stateCode: "IA" },
  { city: "Charleston", state: "South Carolina", stateCode: "SC" },
  { city: "Visalia", state: "California", stateCode: "CA" },
  { city: "Topeka", state: "Kansas", stateCode: "KS" },
  { city: "Elizabeth", state: "New Jersey", stateCode: "NJ" },
  { city: "Gainesville", state: "Florida", stateCode: "FL" },
  { city: "Thornton", state: "Colorado", stateCode: "CO" },
  { city: "Roseville", state: "California", stateCode: "CA" },
  { city: "Carrollton", state: "Texas", stateCode: "TX" },
  { city: "Coral Springs", state: "Florida", stateCode: "FL" },
  { city: "Stamford", state: "Connecticut", stateCode: "CT" },
  { city: "Simi Valley", state: "California", stateCode: "CA" },
  { city: "Concord", state: "California", stateCode: "CA" },
  { city: "Hartford", state: "Connecticut", stateCode: "CT" },
  { city: "Kent", state: "Washington", stateCode: "WA" },
  { city: "Lafayette", state: "Louisiana", stateCode: "LA" },
  { city: "Midland", state: "Texas", stateCode: "TX" },
  { city: "Surprise", state: "Arizona", stateCode: "AZ" },
  { city: "Denton", state: "Texas", stateCode: "TX" },
  { city: "Victorville", state: "California", stateCode: "CA" },
  { city: "Evansville", state: "Indiana", stateCode: "IN" },
  { city: "Santa Clara", state: "California", stateCode: "CA" },
  { city: "Abilene", state: "Texas", stateCode: "TX" },
  { city: "Athens", state: "Georgia", stateCode: "GA" },
  { city: "Vallejo", state: "California", stateCode: "CA" },
  { city: "Allentown", state: "Pennsylvania", stateCode: "PA" },
  { city: "Norman", state: "Oklahoma", stateCode: "OK" },
  { city: "Beaumont", state: "Texas", stateCode: "TX" },
  { city: "Independence", state: "Missouri", stateCode: "MO" },
  { city: "Murfreesboro", state: "Tennessee", stateCode: "TN" },
  { city: "Ann Arbor", state: "Michigan", stateCode: "MI" },
  { city: "Springfield", state: "Illinois", stateCode: "IL" },
  { city: "Berkeley", state: "California", stateCode: "CA" },
  { city: "Peoria", state: "Illinois", stateCode: "IL" },
  { city: "Provo", state: "Utah", stateCode: "UT" },
  { city: "El Monte", state: "California", stateCode: "CA" },
  { city: "Columbia", state: "Missouri", stateCode: "MO" },
  // Add more...
];
